import { createSlice } from '@reduxjs/toolkit';

const calendarSlice = createSlice({
  name: 'calendar',
  initialState: {
    schedules: [],
  },
  reducers: {
    setCalendarData(state, action) {
      state.schedules = action.payload;
    },
    addSchedule(state, action) {
      state.schedules.push(action.payload);
    },
    updateSchedule(state, action) {
      const idx = state.schedules.findIndex(s => s.id === action.payload.id);
      if (idx >= 0) state.schedules[idx] = { ...state.schedules[idx], ...action.payload };
    },
    removeSchedule(state, action) {
      state.schedules = state.schedules.filter(s => s.id !== action.payload);
    },
  },
});

export const { setCalendarData, addSchedule, updateSchedule, removeSchedule } = calendarSlice.actions;
export default calendarSlice.reducer;
